import { useBuildBadgeTemplateFinalSvgString } from '../../../../ui/features/badge-preview/hooks/useBuildBadgeTemplateFinalSvgString';
import React from 'react';
import { BadgeTemplateFinalSvgPreview } from '.';
/**
 * Component that renders non-compiled template to the DOM
 *
 * * to render compiled template use {@link BadgeTemplateFinalSvgPreview}
 */
export const BadgeTemplatePreview = ({ badgeTemplate, badgeTemplateClassifier, formSettings, account, sx, }) => {
    const { badgeTemplateFinalSvg, badgeTemplateSvgError } = useBuildBadgeTemplateFinalSvgString({
        badgeTemplate,
        badgeTemplateClassifier,
        formSettings,
        account,
    });
    return (React.createElement(BadgeTemplateFinalSvgPreview, { badgeTemplateFinalSvg: badgeTemplateFinalSvg, badgeTemplateSvgError: badgeTemplateSvgError, sx: sx }));
};
